import React from 'react';
import {Map} from 'immutable';
import {withSystem, Atom} from '@packages/systems/wfdl';
import {
  iconName,
  pluginName,
  typeName,
  qualify,
} from '@packages/systems/wfdl-Qualified';
import {UsysUtilityPageConstraint, extraAttrs} from './utils';
import {
  USYS_INPUT_TYPES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {TText, TRecord, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {appendUserInputClasses} from '@packages/systems/users/utils/universalUtils';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getBoolean, getInPojo} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const UserFormNameInput = Atom.createRender(
  ({data, context, attributes, classes, generateAttributes}) => {
    const inputClasses = appendUserInputClasses(data, classes);
    const includeNameField = context.get('includeNameField');
    const styledAttributes = includeNameField
      ? attributes
      : attributes.merge(styleDisplayNone);
    const required =
      includeNameField && getBoolean(getInPojo(data, ['required']));
    return (
      <input
        {...generateAttributes(styledAttributes, inputClasses)}
        type="text"
        {...{[USYS_DATA_ATTRS.inputType]: USYS_INPUT_TYPES.name}}
        required={required}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'User Name Field',
  constraints: {
    page: [UsysUtilityPageConstraint],
    ancestors: [
      {
        is: 'UserSignUpForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(pluginName('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: UserFormNameInput,
  fields: {
    attr: TRecord(
      {
        placeholder: withSystem(
          {label: 'Placeholder', isFullWidth: true},
          TText
        ),
      },
      extraAttrs
    ),
    required: withSystem(
      {label: 'Required', labelVariant: 'hidden', defaultValue: true},
      TTypeConstructor(
        qualify(pluginName('Basic'), typeName('ReverseLabelBoolean'))
      )
    ),
  },
});

export default config;
